import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormControl } from '@angular/forms';


@Injectable({
  providedIn: 'root'
})
export class PhoneGradeService {
  url = 'http://localhost:57236/Api/PhoneGrade/';
  constructor(private http: HttpClient) { }

  PhoneGradeRecord(): Observable<any[]> {
    debugger
    return this.http.get<any[]>(this.url + 'PhoneGrdaeList');
  }



  Save(formData: FormData) {
    debugger
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    const httpOptions = { headers: headers };
    return this.http.post(this.url + 'PhoneSKUPriceBulkSave', formData, httpOptions)
  }

  UpdatePhoneRecord(phone: any[]): Observable<any[]> {
    debugger
    return this.http.post<any[]>(this.url + 'updatePhoneGrading', phone);
  }
  PhoneSKURecord(): Observable<any[]> {
    debugger
    return this.http.get<any[]>(this.url + 'PhoneSKUList');
  }

  SaveRecordTodb(data): Observable<any> {
    debugger
    return this.http.post(this.url + 'SaveRecordToDb', data);
  }


  // UpdatePhoneGrade(id:number):Observable<UserRecordsModel>{
  //   alert(id);
  //   return this.http.get<UserRecordsModel>(this.url+'UpdateStatus/'+id ,{
  //     headers: {
  //       "Content-Type": "application/json"
  //     }
  //   });

  // }
}
